import {
    createTheme
} from '@mui/material/styles';


// 全体に適用するテーマを定義
const DerevaTheme = createTheme({
    palette: {
        // 鮮やかな青(Derevaメインカラー)
        primary: {
            main: '#163191',
            contrastText: '#FFFFFF',
        },
        // 淡い水色
        secondary: {
            main: '#8D9AC9',
        },
        // 紺色(secondaryの背景色)
        info: {
            main: '#232F5B',
        },
    },
});

export {
    DerevaTheme
}
